import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAllGamesOptions,
  type GetAllGamesOptionsResponse,
} from '@/application/requests/gamelist';

export const fetchAllGamesForCombobox = createAsyncThunk(
  'game/fetchAllGamesForCombobox',
  async (_, { rejectWithValue }) => {
    try {
      const response: GetAllGamesOptionsResponse = await getAllGamesOptions();

      if (!response.success || !response.data) {
        return rejectWithValue(response.message || 'Failed to fetch all games');
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch all games');
    }
  }
);
